<template>
<div
    dir="rtl"
    :class="$style.profile"
    class="mdc-menu-surface--anchor">
    <m-button
        unelevated
        :leading-icon="`mdc_arrow_drop_${open ? 'up' : 'down'}`"
        :class="$style.button"
        @click.native="onClickButton">
        <profile-image
            :class="$style.image"
            :url="userProfile" />
    </m-button>
    <m-menu
        ref="surface"
        :items="menuItems"
        @selected="onSelect"
        @closed="open = false" />
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mButton from "@/components/mdc/Button.vue";
import ProfileImage from "./ProfileImage.vue";
import mMenu from "@/components/mdc/Menu.vue";
import { naver_mypage } from "@/data/links";
import { DEVELOPER_REGISTER } from "@/router/path";

export default {
    components: { mButton, ProfileImage, mMenu },
    data: () => ({
        open: false
    }),
    computed: {
        ...mapGetters(["userProfile", "isDeveloper"]),
        menuItems() {
            return [
                ...this.isDeveloper
                    ? ["setting", "delete", "logout"]
                    : ["unregister", "setting", "logout"]
            ].map(item => ({
                value: item,
                text: this.$t(`menus.profile.${item}`)
            }));
        }
    },
    watch: {
        open(value) {
            if (value) {
                this.$refs.surface.open();
            }
        }
    },
    methods: {
        ...mapActions(["LOGOUT", "DELETE_ACCOUNT", "UNREGISTER_DEVELOPER"]),
        onSelect({ item: { dataset: { value } } }) {
            switch (value) {
            case "setting":
                this.$nc({}, "gnb.setacnt");
                location.href = naver_mypage;
                return;
            case "register":
                if (this.$route.path !== DEVELOPER_REGISTER) {
                    this.$router.push(DEVELOPER_REGISTER);
                }
                return;
            case "unregister":
                this.UNREGISTER_DEVELOPER();
                return;
            case "delete":
                this.$nc({}, "gnb.delacnt");
                this.DELETE_ACCOUNT();
                return;
            case "logout":
                this.$nc({}, "gnb.logout");
                this.LOGOUT();
            }
        },
        onClickButton(e) {
            this.open = !this.open;
            this.$nc(e, "gnb.my");
        }
    }
};
</script>

<style lang="scss" module>
@use "@material/button";
@use "@material/typography/typography";
@use "@material/list";

.profile {
    .button {
        font-size: typography.px-to-rem(13px);
    }
    .image {
        margin-right: 2px;
    }
    :global {
        .mdc-button {
            @include button.container-fill-color(transparent);
        }
        .mdc-deprecated-list {
            direction: ltr;
            padding: 11px 0px;
            min-width: 160px;
            .mdc-deprecated-list-item {
                height: 34px;
                padding-right: 39px;
                font-size: typography.px-to-rem(14px);
            }
        }
    }
}
</style>
